import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";

const CONTENTFUL_URI = import.meta.env.VITE_CONTENTFUL_URL || "";

const httpLink = new HttpLink({
  uri: CONTENTFUL_URI,
});

const authLink = new SetContextLink(async ({ headers }) => {
  const token = "4cqgVbYe9Atu7mRIl7cBM64O2tQ-FhXdKIjhvGwGlm0";

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const contentfulClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
